module.exports = __webpack_public_path__ + "img/Patronato.0caefcae.png";